<template>
    <div class="flex flex-col justify-center space-y-5 font-body">
        <p class="text-sm text-muval-gray-2">
            This permanently deletes the email. It can't be undone. Only unassigned emails can be deleted — if it
            belongs to an order, move it onto that order instead.
        </p>

        <ErrorDetails :errorData="errorObject" />

        <div class="flex">
            <div class="ml-auto flex gap-5">
                <MuvalButton
                    quaternary
                    type="button"
                    @click.prevent="$emit('cancel:modal')"
                >
                    Cancel
                </MuvalButton>
                <MuvalButton
                    :loading="loading"
                    @click.prevent="onDelete"
                >
                    Delete email
                </MuvalButton>
            </div>
        </div>
    </div>
</template>

<script setup>
import MuvalButton from '@buttons/MuvalButton.vue';
import ErrorDetails from '@components/errors/ErrorDetails.vue';
import { toast } from 'vue-sonner';

const props = defineProps({
    itemId: {
        type: Number,
        required: true,
    },
});

const emit = defineEmits(['close:modal', 'cancel:modal']);

const errorObject = ref({
    message: null,
    errors: null,
});

const loading = ref(false);

async function onDelete() {
    try {
        loading.value = true;
        await window.tenantAxios.delete(`/inbox/${props.itemId}`);
        toast.success('Email deleted.');
        emit('close:modal');
    } catch (error) {
        errorObject.value.message = error.message;
        errorObject.value.errors = error.errors;
        toast.error(error.message ?? 'Failed to delete the email. Please try again.');
    } finally {
        loading.value = false;
    }
}
</script>
